/* eslint-disable max-len */
import React, { useContext, useEffect, useState } from 'react';
import { Box, Flex } from 'rebass/styled-components';

import { layout } from '../../constants/constants';
import Divider from '../../shared/components/divider/divider';
import MenuLabel from '../../shared/components/menu-label/menu-label';
import NavMenuColumn from '../../shared/components/nav-menu-column/nav-menu-column';
import ShIcon from '../../shared/components/sh-icon/sh-icon';
import ShLink from '../../shared/components/sh-link/sh-link';
import { UiStateContext } from '../../shared/contexts/ui-state/UiStateContext';
import useColumnEnd from '../../shared/hooks/column-end/useColumnEnd';
import { GlobalNavProps } from '../../shared/models/app-data-model';
import './aux-nav.scss';

const AuxNav: React.FC<GlobalNavProps> = ({ content, iconPack }: GlobalNavProps) => {
  const uiStateContext = useContext(UiStateContext);

  const [selectedSecondaryNavItem, setSelectedSecondaryNavItem] = useState(
    content.auxiliary_nav?.find((x) => x.primary_nav_item)?.primary_nav_item?.reference.find((el) => el.primary_nav)?.primary_nav
  );

  const [columns, setContent] = useColumnEnd(selectedSecondaryNavItem || []);

  // This hook is responsible for updating our column-end hook whenever our content changes
  useEffect(() => {
    setContent(selectedSecondaryNavItem || []);
  }, [selectedSecondaryNavItem, setContent]);

  const columnRenderings = columns.map((c, index) => <NavMenuColumn key={index} navContent={c.content} columnMaxWidth={'1/2'} />);

  return (
    <Flex className="aux-nav" width="100%">
      {uiStateContext.auxNavOpen && (
        <>
          <Box className="left-menu" width={[1, 1, 1, 1, 4 / 14, 4 / 14, 4 / 16]} pl={layout.pagePaddingX} pr={3} pt={6}>
            <div className="aux-nav">
              {content.auxiliary_nav?.map((item, index) => {
                const secondaryNavContent = item.primary_nav_item?.reference.find((el) => el.primary_nav);
                if (item.menu_label) {
                  return <MenuLabel key={index} label={item.menu_label.text} />;
                }

                if (item.divider) {
                  return <Divider key={index} />;
                }

                if (item.primary_nav_item) {
                  return (
                    <div className="menu-item-wrapper primary-item-title" key={index}>
                      {item.primary_nav_item?.title && (
                        <button
                          className={`menu-item unstyled-btn ${
                            secondaryNavContent?.primary_nav === selectedSecondaryNavItem ? 'active' : ''
                          }`}
                          onClick={() => {
                            setSelectedSecondaryNavItem(secondaryNavContent?.primary_nav ? secondaryNavContent.primary_nav : []);
                          }}
                        >
                          {item.primary_nav_item.title}
                        </button>
                      )}
                      {secondaryNavContent?.primary_nav === selectedSecondaryNavItem && (
                        <ShIcon iconPack={iconPack} iconName="caret_right" className="menu-item-icon" />
                      )}
                    </div>
                  );
                }

                if (item.secondary_nav_item) {
                  return (
                    <div key={item.secondary_nav_item.title + item.secondary_nav_item.reference}>
                      <ShLink
                        key={index}
                        title={item.secondary_nav_item.title}
                        className="secondary-item-link"
                        reference={item.secondary_nav_item.reference}
                      />
                    </div>
                  );
                }
              })}
            </div>
            {content.help && (
              <div>
                <ShLink reference={content.help.reference} className="secondary-item-link" title={content.help.title} />
              </div>
            )}
          </Box>
          <Flex className="right-menu" width={[1, 1, 1, 1, 9 / 14, 9 / 14, 10 / 16]} px={[4, 4, 4, 4, 9]} pt={6}>
            {columnRenderings}
          </Flex>
        </>
      )}
    </Flex>
  );
};

export default AuxNav;
